import { useState, useEffect, useRef } from 'react'

// `ignoredElement`: a click inside it is not an outside click (the element that toggles the popover handles it itself)
const useElementState = (ignoredElement?: Element | null) => {
    const [isClickedOutside, setIsClickedOutside] = useState(false)
    const ref = useRef<HTMLDivElement>(null)
    const ignoredRef = useRef(ignoredElement)
    ignoredRef.current = ignoredElement

    const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as Node
        if (ignoredRef.current?.contains(target)) return

        if (ref.current && !ref.current.contains(target)) {
            setIsClickedOutside(true)
        } else {
            setIsClickedOutside(false)
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    }, [])

    return { ref, isClickedOutside }
}

export default useElementState
